(() => {
  if (window.DaramelStoryShowcase) {
    window.DaramelStoryShowcase.init(document);
    return;
  }

  const initializedSections = new WeakSet();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function revealSection(section) {
    const animationEnabled =
      section.classList.contains('daramel-story--animate') ||
      section.classList.contains('daramel-story-intro--animate');

    if (!animationEnabled || reduceMotion.matches) {
      section.classList.add('is-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        section.classList.add('is-visible');
        observer.disconnect();
      },
      { rootMargin: '0px 0px -10%', threshold: 0.12 }
    );

    observer.observe(section);
  }

  function addPointerMotion(section) {
    if (section.dataset.pointerMotion !== 'true' || reduceMotion.matches) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;

    section.addEventListener('pointermove', (event) => {
      const bounds = section.getBoundingClientRect();
      const x = ((event.clientX - bounds.left) / bounds.width - 0.5) * 14;
      const y = ((event.clientY - bounds.top) / bounds.height - 0.5) * 14;
      section.style.setProperty('--daramel-pointer-x', `${x.toFixed(2)}px`);
      section.style.setProperty('--daramel-pointer-y', `${y.toFixed(2)}px`);
    });

    section.addEventListener('pointerleave', () => {
      section.style.setProperty('--daramel-pointer-x', '0px');
      section.style.setProperty('--daramel-pointer-y', '0px');
    });
  }

  function init(root = document) {
    const sections = root.matches?.('[data-daramel-story]')
      ? [root]
      : root.querySelectorAll('[data-daramel-story]');

    sections.forEach((section) => {
      if (initializedSections.has(section)) return;
      initializedSections.add(section);
      revealSection(section);
      addPointerMotion(section);
    });
  }

  window.DaramelStoryShowcase = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
